import * as Sentry from '@sentry/vue';
const allowedEnvironments = ['production', 'staging', 'release'];

if (allowedEnvironments.includes(useRuntimeConfig().public.environment)) {
  Sentry.init({
    dsn: useRuntimeConfig().public.sentryDSN as string,
    environment: useRuntimeConfig().public.environment as string,
    release: useRuntimeConfig().public.releaseVersion as string,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    sampleRate: 1.0,

    beforeSend(event) {
      return event;
    },
    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      Sentry.replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true
      }),
      Sentry.browserTracingIntegration(),
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: true
      })
    ]
  });
}
